// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import SectionWithHeaderModuleCss from "./SectionWithHeader.module.css";

let classes = SectionWithHeaderModuleCss;

function SectionWithHeader(props) {
  let headerId = props.headerId;
  return <section
    aria-labelledby={headerId}
    className={classes.root + ` ` + Stdlib_Option.getOr(props.className, "")}
  >
    <header>
      <h3
        id={headerId}
      >
        {props.headerSlot}
      </h3>
      {props.buttonsSlot}
    </header>
    <div
      className={Stdlib_Option.getOr(props.noBackground, false) ? "" : Styles.box.base}
    >
      {props.children}
    </div>
  </section>;
}

let make = SectionWithHeader;

export {
  classes,
  make,
}
/* classes Not a pure module */
